import { apiRoutes } from "../../config"
import { api } from "../../utils/lib/api"
import axios from "axios"

export const accInstapago = async (method,ent, data) =>{
    try {
        if(method === "POST"){
            const url = `${apiRoutes.instapago.acc}/${ent}/acc/add`
            return (await api.post(url, data)).data
        }
        if(method === "GET"){
            const url = `${apiRoutes.instapago.acc}/${ent}/acc/${data ? data : ''}`
            return (await api.get(url)).data
        }
    } catch (error) {
        console.error(error)
        return error
    }
}

export const generateTempUrl = async (ent, data) =>{
    try {
        const url = `${apiRoutes.instapago.pay}/${ent}/generate-temp-url`;
        return (await api.post(url, {...data})).data
    } catch (error) {
        console.log(error)
    }
}

export const getOrderData = async (orderId)=>{
    const url = `${apiRoutes.instapago.pay}/order/${orderId}`
    try {
        return (await axios.get(url))?.data.data;
    } catch (error) {
        console.log(error)   
    }
}

export const getPayLink = async (orderId) =>{
    const url = `${apiRoutes.instapago.pay}/get-link/order/${orderId}`
    try {
        return (await api.get(url))?.data.data;
    } catch (error) {
        console.error(error)
    }
}

export const generateQrPay = async(entId, orderId, data)=>{
    const url = `${apiRoutes.instapago.pay}/${entId}/order/${orderId}/generate-qr`
    try {
        return (await axios.post(url, data))?.data.data;
    } catch (error) {
        console.error(error)
    }
}

export const getPaymentInfoClient = async(orderId, data)=>{
    const url = `${apiRoutes.instapago.paymentInfo}`
    try {
        return (await axios.get(url))?.data.data;
    } catch (error) {
        console.error(error)
    }
}

export const verifyMobilePayment = async(entId, orderId, data, payType)=>{
    const url = `${apiRoutes.instapago.pay}/${entId}/${orderId}/verify/${payType}`;
    try {
        const response = await axios.post(url, data);
        return response.data;
    } catch (error) {
        console.error('Error en verifyMobilePayment:', error);
        throw error;
    }
}

export const getBanksAvailable = async()=>{
    const url = `${apiRoutes.instapago.banksAvailable}`;
    try {
        return (await axios.get(url))?.data.data;
    } catch (error) {
        console.error(error)
    }
}

export const createPayLog = async(entId, data)=>{
    const url = `${apiRoutes.instapago.pay}/${entId}/create-pay-log`;
    try {
        const response = await axios.post(url, {...data, enterpriseId: entId});
        return response.data;
    } catch (error) {
        console.error('Error en createPayLog:', error);
        throw error;
    }
}

export const createBankInfo = async(entId, data) => {
    const url = `${apiRoutes.instapago.bankInfo}/${entId}/create-bank-info`;
    try {
        const response = await api.post(url, data);
        return response.data;
    } catch (error) {
        console.error('Error en createBankInfo:', error);
        throw error;
    }
}

export const updateBankInfo = async(entId, bankId, data) => {
    const url = `${apiRoutes.instapago.bankInfo}/${entId}/update-bank-info/${bankId}`;
    try {
        const response = await api.put(url, data);
        return response.data;
    } catch (error) {
        console.error('Error en updateBankInfo:', error);
        throw error;
    }
}

export const getBankInfoByEnterprise = async(entId) => {
    const url = `${apiRoutes.instapago.bankInfo}/${entId}/get-bank-info`;
    try {
        const response = await api.get(url);
        return response.data;
    } catch (error) {
        console.error('Error en getBankInfoByEnterprise:', error);
        throw error;
    }
}

export const getAllBankInfo = async() => {
    const url = `${apiRoutes.instapago.paymentInfo}`;
    try {
        const response = await axios.get(url);
        return response.data;
    } catch (error) {
        console.error('Error en getAllBankInfo:', error);
        throw error;
    }
}